import { setIcons } from "@/utils/common";
import { Button, Space, Switch, Tag } from "antd";
import { decimalReg } from "@/utils/regs";

export const flowingShareholders_options = [
  {
    label: "是",
    value: '1',
  },
  {
    label: "否",
    value: '0',
  },
];
export function columns(props: any) {
  const {
    providers_level,
    setOpen,
    setModalFormData,
    editPrice,
    outDetail,
    authDetail,
    changeSubsidy,
    setuserOutOpen,
    setUserOutFormData,
    userOutFormData,
    linkDetail,
    teamPerformanceDetail
  } = props;
  return [
    {
      title: "用户ID",

      dataIndex: "userBusinessId",
      key: "userBusinessId",
    },
    {
      title: "用户头像",
      dataIndex: "avatar",
      key: "avatar",
      render: (data: string) =>
        data && <img style={{ height: "32px" }} src={data} alt="" />,
    },
    {
      title: "昵称",
      dataIndex: "nickName",
      key: "nickName",
    },
    {
      title: "账号",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "注册方式",
      dataIndex: "userRegType",
      key: "userRegType",
      render: (val: number | string) => (
        <Tag color={val == 0 ? "blue" : "green"}>
          {val == 0 ? "手机号注册" : "邮箱注册"}
        </Tag>
      ),
    },
    {
      title: "佣金金额",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "转赠金额",
      dataIndex: "transferAmount",
      key: "transferAmount",
    },
    // {
    //   title: "积分",
    //   dataIndex: "integral",
    //   key: "integral",
    // },
    {
      title: "充电收益",
      dataIndex: "chargingAmount",
      key: "chargingAmount",
    },
    {
      title: "经销商销售收益",
      dataIndex: "merchantAmount",
      key: "merchantAmount",
    },
    {
      title: "渠道收益",
      dataIndex: "channelAmount",
      key: "channelAmount",
    },
    {
      title: "个性签名",
      dataIndex: "personalizedSignature",
      key: "personalizedSignature",
    },
    {
      title: "推荐人Id",
      dataIndex: "recommendUserId",
      key: "recommendUserId",
    },
    {
      title: "团队属性",
      dataIndex: "teamAttribute",
      key: "teamAttribute",
    },
    // {
    //   title: "分佣类型",
    //   dataIndex: "deviceFlowRewardType",
    //   key: "deviceFlowRewardType",
    //   render: (val: number) => (
    //     <Tag color="blue">
    //       {val === 0 ? "通用模式" : val === 1 ? "自定义模式" : "不分佣"}
    //     </Tag>
    //   ),
    // },
    // {
    //   title: "佣金最大值",
    //   dataIndex: "deviceFlowRewardMax",
    //   key: "deviceFlowRewardMax",
    // },
    // {
    //   title: "佣金最小值",
    //   dataIndex: "deviceFlowRewardMin",
    //   key: "deviceFlowRewardMin",
    // },
    {
      title: "收货地址",
      dataIndex: "address",
      key: "address",
      render: (val: string, rows: any) => (
        <div>{rows.provinceName + rows.cityName + rows.districtName || ""}</div>
      ),
    },
    {
      title: "创建时间",
      dataIndex: "createTime",
      key: "createTime",
      // render: (val: string) => <div>{getTimeFormat(val)}</div>
    },
    {
      title: "用户等级",
      dataIndex: "userLevel",
      key: "userLevel",
      render: (val: string) => (
        <Tag color="blue">
          {
            providers_level?.find((i: { value: string }) => i.value === val)
              ?.label
          }
        </Tag>
      ),
    },
    {
      title: "用户类型",
      dataIndex: "userType",
      key: "userType",
      render: (val: string) => (
        <Tag color="blue">{val === "0" ? "管理" : "普通"}</Tag>
      ),
    },
    {
      title: "补贴",
      dataIndex: "skipBuTie",
      key: "skipBuTie",
      render: (val: number, rows: any) => (
        <Switch onChange={(e) => changeSubsidy(rows)} checked={val === 1} />
      ),
    },
      {
        title: "流水股东",
        dataIndex: "flowingShareholders",
        key: "flowingShareholders",
        render: (val: string, rows: any) => (
          flowingShareholders_options.find((i: { value: string }) => i.value === val)
            ?.label
        ),
      },

    {
      title: "操作",
      dataIndex: "userId",
      key: "userId",
      fixed: "right",
      render: (val: string, rows: any) => (
        <Space size="small">
          {rows.userStatus === "0" ? (
            <>
              <Button
                size="small"
                // icon={setIcons("CloudUploadOutlined")}
                type="link"
                onClick={(e) => {
                  setOpen(true);
                  setModalFormData({
                    userId: val,
                  });
                }}
              >
                添加金额
              </Button>
              <Button
                size="small"
                // icon={setIcons("EditOutlined")}
                type="link"
                onClick={() => {
                  outDetail(val);
                }}
              >
                修改
              </Button>
              <Button
                size="small"
                type="link"
                onClick={(e) => {
                  teamPerformanceDetail(rows);
                }}
              >
                团队业绩
              </Button>
              <Button
                size="small"
                type="link"
                onClick={(e) => {
                  linkDetail(val);
                }}
              >
                链路详情
              </Button>
          
              <Button
                size="small"
                // icon={setIcons("ContactsOutlined")}
                type="link"
                onClick={() => {
                  authDetail(rows);
                }}
              >
                团队属性
              </Button>
            </>
          ) : (
            <></>
          )}

          <Button
            size="small"
            // icon={setIcons("SnippetsOutlined")}
            type="link"
            onClick={() => {
              setuserOutOpen(true);
              setUserOutFormData({
                ...userOutFormData,
                userId: val,
              });
            }}
          >
            推荐人变更
          </Button>
        </Space>
      ),
    },
  ];
}

export const linkColumns = [
  {
    title: "用户ID",
    dataIndex: "userId",
    key: "userId",
  },
  {
    title: "昵称",
    dataIndex: "nickName",
    key: "nickName",
  },
  {
    title: "手机号",
    dataIndex: "mobile",
    key: "mobile",
  },
  // {
  //   title: "关系路径",
  //   dataIndex: "recommenderPath",
  //   key: "recommenderPath",
  // },
  {
    title: "推荐者Id",
    dataIndex: "recommendUserId",
    key: "recommendUserId",
  },
  {
    title: "用户等级",
    dataIndex: "userLevel",
    key: "userLevel",
  },
  {
    title: "备注",
    dataIndex: "remark",
    key: "remark",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
  },
];

export const formTab = (providers_level: any, cascaderProps: any) => [
  {
    label: "账号",
    name: "mobile",
    type: "input",
  },
  {
    label: "用户昵称",
    name: "nickName",
    type: "input",
    width: "280px",
  },
  {
    label: "推荐人手机号",
    name: "recommendMobile",
    type: "input",
    width: "280px",
  },
  {
    label: "团队属性",
    name: "teamAttribute",
    type: "input",
    width: "280px",
  },
  {
    label: "用户等级",
    name: "userLevel",
    type: "select",
    options: providers_level,
  },
  {
    label: "用户类型",
    name: "userType",
    type: "select",
    options: [
      {
        label: "管理",
        value: "0",
      },
      {
        label: "普通",
        value: "1",
      },
    ],
  },
  {
    label: "流水股东",
    name: "flowingShareholders",
    type: "select",
    options: flowingShareholders_options,
  },
  {
    label: "区域范围",
    name: "channelName",
    type: "cascader",
    params: {
      ...cascaderProps,
      onChange: (value: any, selectedOptions: any) => {
        console.log(value, selectedOptions);
      },
    },
  },
  {
    label: "时间范围",
    name: "rangePicker",
    type: "rangePicker",
    width: "380px",
  },
];

export const amountType = [
  {
    label: "佣金金额",
    value: "1",
  },
  {
    label: "转赠金额",
    value: "3",
  },
  {
    label: "充电收益",
    value: "4",
  },
  {
    label: "经销商销售收益",
    value: "5",
  },
  {
    label: "渠道收益",
    value: "7",
  },
];


export const modalFormTab = [
  {
    label: "数额方式",
    name: "accountTrend",
    type: "select",
    labelCol1: { span: 0, offset: 1 },
    rules: [{ required: true, message: "请选择类型" }],
    options: [
      {
        label: "赚取",
        value: "1",
      },
      {
        label: "消耗/扣减",
        value: "2",
      },
    ],
  },
  {
    label: "添加类型",
    name: "accountType",
    type: "select",
    rules: [{ required: true, message: "请选择类型" }],
    labelCol1: { span: 0, offset: 1 },
    options: amountType,
  },
  {
    label: "数额",
    name: "amount",
    type: "input",
    rules: [
      { required: true, message: "请输入数额" },
      {
        pattern: decimalReg,
        message: "请输入正确数额",
      },
    ],
  },
];